import { Component, OnInit, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AskingAlert } from '../models/alert';
import { AlertService } from '../services/alert.service';
import { ApiService } from '../services/api.service';
import { PaginationFacadeService } from '../store/pagination/pagination-facade.service';
import { PaginationState } from '../store/pagination/pagination.state';
// import { ExportToCsv } from 'export-to-csv-file';
import { ToastrService } from 'ngx-toastr';
import { getAuthItem } from '../store/auth/auth-session';
@Component({
    selector: 'app-global-list',
    template: ``,
})
export abstract class GlobalListComponent implements OnInit {
    dataItems: any = [];
    pagination: any;
    pageNumber: any = 1;
    limit: any = 10;
    listApi!: string;
    customFilters: any = {};
    filterBody: any = {};
    detailUrl!: string;
    deleteUrl!: string;
    paginationUrl!: string;
    type: any;
    sort = {
        column: '',
        order: 'ASC',
    };
    sub!: Subscription;
    tableProps: any = {};
    sortColumn = 'id';
    searchStr = '';
    filters: any;
    posts: any[] = []; // for only tesing purpose
    formUrl: string = '';
    searchKey: any = 'search';
    userInfo: any;

    router = inject(Router)
    _route = inject(ActivatedRoute);
    apiService = inject(ApiService);
    paginationFacadeService = inject(PaginationFacadeService);
    alertService = inject(AlertService);
    toastr = inject(ToastrService);


    ngOnInit() {
        this.dataItems = [];
        this.pagination = {
            page: this.pageNumber,
            pages: this.limit,
            limit: 10,
            count: 100,
        };
        this.paginationUrl = `?page=${this.pagination.page}&limit=${this.pagination.limit}&SortColumn=${this.sortColumn}&sort_order=DESC`;
        this.getuser();
        this.sub = this._route.params.subscribe((params) => {
            this.type = params['type'];
        });
    }

    getuser() {
        const pouchAdminStr = getAuthItem('user');
        this.userInfo = pouchAdminStr ? JSON.parse(pouchAdminStr) : null;
        return this.userInfo;
    }


    getUpdatedPagination() {
        if (this.paginationFacadeService && this.paginationFacadeService.pagination$) {
            this.paginationFacadeService.pagination$.subscribe(
                (pagination: PaginationState) => {
                    this.pageNumber = pagination?.pageNumber || 1;
                    this.limit = pagination?.pageSize || 10;
                    if (!this.pagination) {
                        this.pagination = {
                            page: this.pageNumber,
                            pages: this.limit,
                        };
                    }
                    // this.pagination.page = pagination?.pageNumber || 1;
                    // this.pagination.pages = pagination?.pageSize || 10;
                    // this.paginationUrl = `?page=${this.pageNumber}&limit=${this.limit}&SortColumn=${this.sortColumn}&sort_order=DESC`;
                    this.paginationUrl = `?page=${this.pageNumber}&limit=${this.limit}`;
                }
            );
        } else {
            // Fallback if pagination service is not available
            this.pageNumber = this.pageNumber || 1;
            this.limit = this.limit || 10;
            this.paginationUrl = `?page=${this.pageNumber}&limit=${this.limit}`;
        }
    }

    onClickActionRoute(url: string): void {
        this.router.navigateByUrl(url);
    }

    onDateRange(event: any): void {

    }

    onPagination(event: any): void {
        this.pageNumber = event.page;
        this.limit = event.limit;

        this.paginationFacadeService.setPaginationData({
            pageNumber: this.pageNumber,
            pageSize: this.limit,
        });

        this.paginationUrl = `?page=${this.pageNumber}&limit=${this.limit}&SortColumn=${this.sortColumn}&sort_order=DESC`;
        this.getList();
    }

    setPage(event: any) {
        this.pageNumber = event.page;
        this.limit = event.limit;
        this.paginationFacadeService.setPaginationData({
            pageNumber: this.pageNumber,
            pageSize: this.limit,
        });
        this.getListPost();
    }

    finalFilters(event: any): void {
        let filterUrl = '';

        if (event.sort) {
            filterUrl = filterUrl + event.sort;
        }
        if (event.range) {
            filterUrl = filterUrl + event.range;
        }
        if (event.search) {
            filterUrl = filterUrl + `&search=${event.search}`;
        }

        if (event.date) {
            filterUrl = filterUrl + event.date;
        }

        if (event.dateFilter) {
            filterUrl = filterUrl + event.dateFilter;
        }

        if (event.dropDownFilter) {
            filterUrl = filterUrl + event.dropDownFilter;
        }

        this.getList(filterUrl);
    }

    getList(filterUrl?: any, isPublic?: boolean, isHideLoader?: boolean): void {
        this.getUpdatedPagination();
        let url = this.listApi;

        if (this.paginationUrl) {
            if (url.includes('?')) {
                url = url + '&' + this.paginationUrl.replace(/^\?/, '');
            } else {
                url = url + '?' + this.paginationUrl.replace(/^\?/, '');
            }
        }

        if (this.searchStr && !url.includes(this.searchKey)) {
            url = `${url}&${this.searchKey}=${this.searchStr}`;
        } else {

        }

        Object.assign(this.filterBody, this.customFilters);
        if (this.customFilters.type) {
            // url = `${url}&type=${this.customFilters.type}`;
        }

        this.apiService
            .get(url, this.filterBody, isPublic, isHideLoader)
            .subscribe((result: any) => {
                if (result?.status == 200) {
                    if (result.data != null) {
                        this.dataItems = result.data;
                    } else {
                        this.dataItems = [];
                    }
                    const paginationInfo = result.data?.pagination_info || result.pagination || result || {};

                    this.pagination = {
                        page: paginationInfo.page
                            || paginationInfo.currentPage
                            || this.pageNumber,

                        pages: paginationInfo.pages
                            || paginationInfo.totalPages || paginationInfo.total_pages
                            || 0,

                        limit: paginationInfo.per_page
                            || paginationInfo.limit
                            || 0,

                        count: paginationInfo.totalItems
                            || paginationInfo.count || paginationInfo.total_items
                            || 0
                    };
                    this.afterListResponse();
                    // handle logs api res
                } else if (result?.data || Array.isArray(result)) {

                    if (result.data != null) {
                        this.dataItems = result.data;
                    } else if (result) {
                        this.dataItems = result;
                    } else {
                        this.dataItems = [];
                    }
                    const paginationInfo = result.data?.pagination_info || result.pagination || result || {};

                    this.pagination = {
                        page: paginationInfo.page
                            || paginationInfo.currentPage
                            || this.pageNumber,

                        pages: paginationInfo.pages
                            || paginationInfo.totalPages
                            || 0,

                        limit: paginationInfo.limit
                            || paginationInfo.perPage
                            || 0,

                        count: paginationInfo.totalItems
                            || paginationInfo.count
                            || 0
                    };
                    this.afterListResponse();
                } else if (result?.app_versions) {
                    const versionsArray: any[] = [];
                    Object.keys(result.app_versions).forEach(app => {
                        if (app !== 'pouchServicePrice') {
                            Object.keys(result.app_versions[app]).forEach(type => {
                                const item = result.app_versions[app][type];
                                versionsArray.push({
                                    app: app,
                                    type: type,
                                    forceUpdate: item.force,
                                    version: item.version
                                });
                            });
                        }
                    });
                    this.dataItems = versionsArray;
                    this.afterListResponse();
                }
                else {
                    this.dataItems = [];
                }
            });
    }

    // for use of mock api testing purpose
    getPosts() {
        const startIndex = (this.pageNumber - 1) * this.pageNumber;
        const endIndex = startIndex + this.limit;
        const totalPosts = this.posts.length;
        const totalPages = Math.ceil(totalPosts / this.limit);

        return {
            status: 'success',
            statusCode: 200,
            message: 'OK',
            data: {
                list: this.posts.slice(startIndex, endIndex),
                pagination: {
                    page: this.pageNumber,
                    pages: totalPages,
                    count: totalPosts,
                    limit: this.limit,
                    sort_by: 'id',
                    sort_order: 'DESC',
                },
            },
            error: null,
        };
    }

    getListPost(obj?: any, isPublic?: boolean, isHideLoader?: boolean): void {
        this.getUpdatedPagination();
        let url = this.listApi;
        obj['page'] = this.pageNumber;
        obj['limit'] = this.limit;
        obj['sortColumn'] = this.sortColumn;

        if (this.searchStr) {
            obj['search'] = this.searchStr;
            this.searchStr = '';
        }

        this.apiService
            .post(url, obj, isPublic, isHideLoader)
            .subscribe((result) => {
                if (result.statusCode == 200) {
                    this.dataItems = result.data;
                    // this.pagination = result.data.pagination_info;
                    this.pagination.page = result.data?.pagination_info?.page || this.pageNumber;
                    this.pagination.pages = result.data?.pagination_info?.pages;
                    this.pagination.limit = result.data?.pagination_info?.limit;
                    this.pagination.count = result.data?.pagination_info?.totalItems;
                    this.afterListResponse();
                } else {
                    this.dataItems = [];
                    this.alertService.error({
                        heading: 'Error',
                        message: result.message,
                    });
                }
            });
    }

    afterListResponse(): void { }

    onDelete(id: any) {
        let url = `${this.deleteUrl}${id}`
        let data: AskingAlert = {
            imagePath: 'icons/ic_delete_bg.svg',
            heading: 'Delete',
            message: 'Are you sure you want to delete this record?',
            leftButton: 'Delete',
            rightButton: 'Cancel',
        };
        this.alertService.askAlert(data, '400px').then((result: any) => {
            if (result.key) {
                this.apiService.delete(url).subscribe((result: any) => {
                    if (result.status == 200) {
                        this.getList();
                        this.toastr.success(result.message);
                    } else {
                        this.alertService.error({
                            heading: 'Error',
                            message: result.message,
                        });
                    }
                });
            } else {
            }
        });
    }

    actionClicked(event: any) {

        if (event.action.type == 'view') {
            this.router.navigateByUrl(`${this.formUrl}${event.action.type}/${event.element.id}`);
        } else if (event.action.type == 'edit') {
            this.router.navigateByUrl(`${this.formUrl}${event.action.type}/${event.element.id}`);
        }
        else if (event.action.type == 'delete') {
            this.onDelete(event.element.id);
        }
    }

    searchData(event: any) {
        this.pageNumber = 1;
        this.limit = 10;
        this.searchStr = event;
        this.getList();
    }

    searchPostData(event: any): void {
        this.pageNumber = 1;
        this.limit = 10;
        this.searchStr = event;
        this.getListPost();
    }

    onChangeDateFilters(event: any) {
        this.pageNumber = 1;
        this.limit = 10;

        this.getList();
    }

    onDateFilters(event: any) {

    }

    createFormDataDynamically(obj: any) {
        const formData = new FormData();
        Object.keys(obj).forEach(key => {
            if (obj[key] !== null && obj[key] !== undefined) {
                formData.append(key, obj[key]);
            }
        });
        return formData;
    }

    onChangefilter(event: any) { }

    formatStatusKey(status: string): string {
        if (!status) {
            return ''
        }

        return status
            .replace(/_/g, ' ')
            .replace(/\b\w/g, char => char.toUpperCase());
    }

    onExportCsv(data: any[], fileName: string) {
        const options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: false, // header row off
            useBom: true,
            filename: fileName,
            useKeysAsHeaders: false
        };
        // const csvExporter = new ExportToCsv(options);
        // csvExporter.generateCsv(data);
        this.toastr.success('CSV downloaded successfully!');
    }
}


